/**
 * NotificationContext.jsx
 * Tatalli Cloud — Global Bildirim Bağlamı
 * WebSocket üzerinden gelen bildirimleri yönetir.
 */

import React, { createContext, useContext, useState } from 'react';

const BildirimBaglami = createContext();

export const useNotifications = () => useContext(BildirimBaglami);

export const NotificationProvider = ({ children }) => {
  const [bildirimler, setBildirimler] = useState([]);

  const bildirimEkle = (n) => {
    const simdi = Date.now();
    const id = simdi + Math.random();
    const zaman = n.timestamp || simdi;

    setBildirimler(onceki => {
      const mevcut = onceki.find(x => x.title === n.title && x.message === n.message);
      if (mevcut) {
        return onceki.map(x => x.id === mevcut.id ? { ...x, timestamp: simdi } : x);
      }
      return [{ id, ...n, timestamp: zaman }, ...onceki].slice(0, 5);
    });

    const gecen  = Date.now() - zaman;
    const kalan  = Math.max(5000 - gecen, 1200);
    setTimeout(() => {
      setBildirimler(onceki => onceki.filter(x => x.id !== id));
    }, kalan);
  };

  const bildirimKaldir = (id) => {
    setBildirimler(onceki => onceki.filter(x => x.id !== id));
  };

  return (
    <BildirimBaglami.Provider value={{
      notifications   : bildirimler,
      pushNotification: bildirimEkle,
      removeNotification: bildirimKaldir,
    }}>
      {children}
    </BildirimBaglami.Provider>
  );
};
